(function($, Drupal) {
  'use strict';

  Drupal.behaviors.productDetails = {
    attach: function(context, settings) {
      //* Adds Slick Slider to articles page, only if there are more than 1 image
      let $product_details = $('.product-detail-item');
      if ($product_details) {
        $product_details.last().addClass('product-detail-item--last');
      }
    }
  };
})(jQuery, Drupal);
